module.exports = __webpack_public_path__ + "img/caigou.4e52eb91.png";